export default __webpack_public_path__ + "static/article-common-mistakes-when-buying-a-car-2f815748537982feea0dae6652a5df13.jpg";